import gql from 'graphql-tag';
import * as Apollo from '@apollo/client';
import * as Types from '../../../../../server/graphql/__generated.types';

const defaultOptions = {} as const;
export type StudioRoutesQueryVariables = Types.Exact<{ [key: string]: never }>;

export type StudioRoutesQuery = {
  __typename?: 'Query';
  studioRoutes: Array<{ __typename?: 'StudioRoute'; route: string; label: string }>;
};

export const StudioRoutesDocument = gql`
  query StudioRoutes {
    studioRoutes {
      route
      label
    }
  }
`;

/**
 * __useStudioRoutesQuery__
 *
 * To run a query within a React component, call `useStudioRoutesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudioRoutesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudioRoutesQuery({
 *   variables: {
 *   },
 * });
 */
export function useStudioRoutesQuery(
  baseOptions?: Apollo.QueryHookOptions<StudioRoutesQuery, StudioRoutesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<StudioRoutesQuery, StudioRoutesQueryVariables>(
    StudioRoutesDocument,
    options
  );
}
export function useStudioRoutesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<StudioRoutesQuery, StudioRoutesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<StudioRoutesQuery, StudioRoutesQueryVariables>(
    StudioRoutesDocument,
    options
  );
}
export type StudioRoutesQueryHookResult = ReturnType<typeof useStudioRoutesQuery>;
export type StudioRoutesLazyQueryHookResult = ReturnType<typeof useStudioRoutesLazyQuery>;
export type StudioRoutesQueryResult = Apollo.QueryResult<
  StudioRoutesQuery,
  StudioRoutesQueryVariables
>;
